module.exports = __webpack_public_path__ + "static/img/image4.2d135573.png";